import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';
import { G_TABLE__inputs__base } from '../_base/G_TABLE__inputs__base';
import { HOOK_TABLE_LAYOUT__inputs__image_asset } from './HOOK_TABLE_LAYOUT__inputs__image_asset';

interface PROPS {
  fields: FIELD__image_asset[];
}

export function G_TABLE__inputs__image_asset({ fields }: PROPS) {
  const columns = HOOK_TABLE_LAYOUT__inputs__image_asset({ fields });

  return <G_TABLE__inputs__base {...{ columns }} title={'IMAGES'} fields={fields} />;
}
